import { useQuery } from '@tanstack/react-query';
import { pluginsApi } from '../api/pluginsApi';

/**
 * GET /api/eraf/gateway/plugins — 정적 레지스트리(정확히 7건)이므로 자주 바뀌지 않는다.
 * refetchInterval 없이 긴 staleTime 만 적용.
 */
export function usePluginsQuery() {
  return useQuery({
    queryKey: ['gateway', 'plugins'],
    queryFn: () => pluginsApi.list(),
    staleTime: 10 * 60_000,
  });
}
